(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu-item-level-1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const level1Items = document.querySelectorAll('.menu-drawer__level-1-item');
    level1Items.forEach((item) => {
      const button = item.querySelector('button');
      const itemRef = item;
      if (button) {
        button.addEventListener('click', function () {
          level1Items.forEach((item) => {
            if (item === itemRef) return;
            item.classList.remove('menu-drawer__level-1-item--open');
          });

          item.classList.toggle('menu-drawer__level-1-item--open');
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
